import { HorizontalContainer } from '@american-autonomy/ag-ui';

import CautionStatusBadge from 'components/badges/CautionStatusBadge';
import CriticalStatusBadge from 'components/badges/CriticalStatusBadge';
import GoodStatusBadge from 'components/badges/GoodStatusBadge';
import GroundedStatusBadge from 'components/badges/GroundedStatusBadge';
import HoldStatusBadge from 'components/badges/HoldStatusBadge';
import ReadyStatusBadge from 'components/badges/ReadyStatusBadge';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const badgeMap = {
    CAUTION: CautionStatusBadge,
    CRITICAL: CriticalStatusBadge,
    GOOD: GoodStatusBadge,
    GROUNDED: GroundedStatusBadge,
    HOLD: HoldStatusBadge,
    READY: ReadyStatusBadge
};

const Badges: FunctionComponent<Props> = ({ className = '', items, testId = TEST_ID }) => (
    <HorizontalContainer className={`${className} ${styles.badges}`} testId={testId}>
        {items.map(item => {
            const Badge = badgeMap[item];

            return <Badge key={item} />;
        })}
    </HorizontalContainer>
);

export default Badges;
